/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListSecretsResponse } from '../../models/list-secrets-response';

export interface ListAllSecrets$Params {
  organizationId: string;
}

export function listAllSecrets(http: HttpClient, rootUrl: string, params: ListAllSecrets$Params, context?: HttpContext): Observable<StrictHttpResponse<ListSecretsResponse>> {
  const rb = new RequestBuilder(rootUrl, listAllSecrets.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ListSecretsResponse>;
    })
  );
}

listAllSecrets.PATH = '/v1/organizations/{organizationId}/secrets';
